import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["background", "panel"];

  open(event) {
    event.preventDefault();
    this.backgroundTarget.classList.remove("hidden");
    this.panelTarget.classList.add("translate-x-0");
    this.panelTarget.classList.remove("translate-x-full");
  }

  close() {
    this.panelTarget.classList.add("translate-x-full");
    this.panelTarget.classList.remove("translate-x-0");
    setTimeout(() => {
      this.backgroundTarget.classList.add("hidden");
    }, 500);
  }
}
